import Timeline from '@mui/lab/Timeline'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineContent from '@mui/lab/TimelineContent'
import { TimelineOppositeContent } from '@mui/lab'
import { Stack, Typography } from '@vapor/material'
import { EmailState, EmailStateTransaction } from 'src/api/api.generated'
import i18n from 'src/locales/i18n'
import { useTranslation } from 'react-i18next'

type MailStateTimelineProps = {
  getStateString: (state: EmailState) => string
  getStateIsError: (state: EmailState) => boolean
  timeline: EmailStateTransaction[]
}

export default function MailStateTimeline(props: MailStateTimelineProps) {
  const { timeline, getStateString, getStateIsError } = props
  const { t } = useTranslation()

  return (
    <Stack direction="column" justifyContent="center" alignItems="flex-start" spacing={-1} pt={'14px'} pl={1} pr={1}>
      <Typography variant="titleSmall">{t('pms.mail_log_drawer.message_log_popover.title')}</Typography>
      <Timeline>
        <>
          {timeline.map((state, index) => {
            return (
              <TimelineItem key={state.state}>
                <TimelineSeparator>
                  <Stack
                    sx={{
                      height: '40px',
                      width: '40px',
                      borderRadius: '50%',
                      backgroundColor: !getStateIsError(state.state) ? 'var(--RichElectricBlue)' : 'var(--warning)',
                      marginTop: '10px',
                      marginBottom: '8px',
                    }}
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Typography variant="titleSmall" color="white">
                      {index + 1}
                    </Typography>
                  </Stack>
                  {index < timeline.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineOppositeContent sx={{ flex: 0, paddingRight: 0, paddingLeft: 0 }} />
                <TimelineContent>
                  <Stack direction="column" spacing={-0.5} justifyContent="center" alignItems="flex-start">
                    <Typography variant="titleXSmall">
                      <b>{getStateString(state.state)}</b>
                    </Typography>
                    <Typography variant="body">{state.timestamp.toLocaleDateString(i18n.language, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}</Typography>
                    {state.result && (
                      <Typography variant="body" maxWidth="350px">
                        {state.result}
                      </Typography>
                    )}
                  </Stack>
                </TimelineContent>
              </TimelineItem>
            )
          })}
        </>
      </Timeline>
    </Stack>
  )
}
